export default "__VITE_ASSET__mSF$dCM6__"